import React, { Component } from "react";
import SimpleCertificationSection from "../certifications/SimpleCertificationSection";

class GallerySection extends Component {
  render() {
    return <SimpleCertificationSection />;
  }
}

export default GallerySection;
